import { useState } from "react";
import { useTranslation } from 'react-i18next';
import RangeSlider from '../Compartido/RangeSlider';


const FilterSection = ({ selectedDestination, onDestinationChange, destinos, propiedades, destino, adultos, ninos, llegada, salida }) => {

    const { t } = useTranslation();

    // 1. Creamos un array solo con los precios
    const precios = propiedades.map(p => p.precio);

    const preciosValidos = (precios ?? []).filter(precio => precio != null);

    // 2. Encontramos el mínimo y máximo
    const precioMinimo = preciosValidos.length > 0 ? Math.min(...preciosValidos) / 100 : Number(0);
    const precioMaximo = preciosValidos.length > 0 ? Math.max(...preciosValidos) / 100 : Number(1000);

    const [isOpenDestino, setIsOpenDestino] = useState(false);
    const [isOpenInstalaciones, setIsOpenInstalaciones] = useState(false);
    const [isOpenRangoPrecios, setIsOpenRangoPrecios] = useState(false);
    const [isOpenServicios, setIsOpenServicios] = useState(false);
    const [isOpenPromociones, setIsOpenPromociones] = useState(false);

    const [showFilters, setShowFilters] = useState(false);
    const [selectedBrands, setSelectedBrands] = useState([]);
    const [selectedAmenities, setSelectedAmenities] = useState([]);
    const [priceRange, setPriceRange] = useState([169, 414]);

    const handlePriceChange = (min, max) => {
        console.log(`Rango seleccionado: €${min} - €${max}`);
    };

    const toggleBrand = (brand) => {
        setSelectedBrands(prev =>
            prev.includes(brand)
                ? prev.filter(b => b !== brand)
                : [...prev, brand]
        );
    };

    const toggleAmenity = (amenity) => {
        setSelectedAmenities(prev =>
            prev.includes(amenity)
                ? prev.filter(a => a !== amenity)
                : [...prev, amenity]
        );
    };

    return (
        <div className="col-md-3" >
            <div className="c-clp-filtros collapse show">
                <div className="c-clp-filtros_header d-md-none">
                    <p className="mb-0">{t("Filtros")}</p>
                    <button type="button" className="btn btn-close"></button>
                </div>
                <div className="c-clp-filtros_body">
                    <div className="d-flex align-items-center justify-content-between">
                        <p className="mb-0 text-sm">{t("Filtrar por:")}</p>
                        <button type="button" className="btn btn-clean-filtro"> {t("Limpiar filtros")} </button>
                    </div>
                    <div className="accordion">
                        <div className="accordion-item" id="ngb-accordion-item-0">
                            <button type="button" ngbaccordionbutton="" className="accordion-button collapsed" id="ngb-accordion-item-0-toggle" aria-controls="ngb-accordion-item-0-collapse" aria-expanded="false" onClick={() => setIsOpenDestino(!isOpenDestino)}>

                                <i className="fa-solid fa-location-dot" style={{ paddingRight: "10px" }}></i>{" "}<strong >{t("DESTINO")}</strong>
                            </button>
                            <div role="region" ngbaccordioncollapse="" id="ngb-accordion-item-0-collapse" aria-labelledby="ngb-accordion-item-0-toggle" className={`accordion-collapse collapse ${isOpenDestino ? 'show' : ''}`} >
                                <div ngbaccordionbody="" className="accordion-body">
                                    {destinos.map((undestino, index) => (
                                        <div className="mb-2 form-check" key={index}>
                                            <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id={`dest_${index}`} />
                                            <label className="form-check-label" htmlFor="dest_0_Barcelona">{undestino.elnombre}</label>
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </div>
                        <div className="accordion-item" id="ngb-accordion-item-2">
                            <button type="button" ngbaccordionbutton="" className="accordion-button collapsed" id="ngb-accordion-item-2-toggle" aria-controls="ngb-accordion-item-2-collapse" aria-expanded="false" onClick={() => setIsOpenInstalaciones(!isOpenInstalaciones)}>

                                <i className="fa-solid fa-building" style={{ paddingRight: "10px" }}></i>{" "}<strong >{t("INSTALACIONES")}</strong>
                            </button>
                            <div role="region" ngbaccordioncollapse="" id="ngb-accordion-item-2-collapse" aria-labelledby="ngb-accordion-item-2-toggle" className={`accordion-collapse collapse ${isOpenInstalaciones ? 'show' : ''}`}>
                                <div ngbaccordionbody="" className="accordion-body">
                                    {/*
                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="inst_0_Hoteles de ciudad" />
                                        <label className="form-check-label" htmlFor="inst_0_Hoteles de ciudad"> {t("De ciudad")} </label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="inst_1_Hoteles vacacionales" />
                                        <label className="form-check-label" htmlFor="inst_1_Hoteles vacacionales"> {t("Vacacionales")} </label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="inst_2_Hoteles vacacionales en la costa e islas españolas" />
                                        <label className="form-check-label" htmlFor="inst_2_Hoteles vacacionales en la costa e islas españolas"> {t("Vacacionales en la costa e islas españolas")} </label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="inst_3_Hoteles familiares" />
                                        <label className="form-check-label" htmlFor="inst_3_Hoteles familiares"> {t("Familiares")} </label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="inst_4_Terraza" />
                                        <label className="form-check-label" htmlFor="inst_4_Terraza"> {t("Terraza")} </label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="inst_5_Rooftop" />
                                        <label className="form-check-label" htmlFor="inst_5_Rooftop"> {t("Rooftop")} </label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="inst_6_Piscinas" />
                                        <label className="form-check-label" htmlFor="inst_6_Piscinas"> {t("Piscinas")} </label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="inst_7_Infinity pool" />
                                        <label className="form-check-label" htmlFor="inst_7_Infinity pool"> {t("Infinity pool")} </label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="inst_8_Río lento" />
                                        <label className="form-check-label" htmlFor="inst_8_Río lento"> {t("Río lento")} </label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="inst_9_Parque acuático" />
                                        <label className="form-check-label" htmlFor="inst_9_Parque acuático"> {t("Parque acuático")} </label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="inst_10_Barco pirata" />
                                        <label className="form-check-label" htmlFor="inst_10_Barco pirata"> {t("Barco pirata")} </label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="inst_11_Dive It" />
                                        <label className="form-check-label" htmlFor="inst_11_Dive It"> {t("Dive It")} </label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="inst_12_Cycling" />
                                        <label className="form-check-label" htmlFor="inst_12_Cycling"> {t("Cycling")}</label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="inst_13_Pistas de tenis" />
                                        <label className="form-check-label" htmlFor="inst_13_Pistas de tenis"> {t("Pistas de tenis")} </label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="inst_14_Gimnasio" />
                                        <label className="form-check-label" htmlFor="inst_14_Gimnasio"> {t("Gimnasio")} </label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="inst_15_Bolera" />
                                        <label className="form-check-label" htmlFor="inst_15_Bolera"> {t("Bolera")} </label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="inst_16_Habitaciones familiares" />
                                        <label className="form-check-label" htmlFor="inst_16_Habitaciones familiares"> {t("Habitaciones familiares")} </label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="inst_17_Habitaciones adaptadas" />
                                        <label className="form-check-label" htmlFor="inst_17_Habitaciones adaptadas"> {t("Habitaciones adaptadas")} </label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="inst_18_Piscinas con silla hidráulica" />
                                        <label className="form-check-label" htmlFor="inst_18_Piscinas con silla hidráulica"> {t("Piscinas con silla hidráulica")} </label>
                                    </div>
                                    */}

                                </div>

                            </div>
                        </div>
                        <div className="accordion-item" id="ngb-accordion-item-14">
                            <button type="button" ngbaccordionbutton="" className="accordion-button collapsed" id="ngb-accordion-item-14-toggle" aria-controls="ngb-accordion-item-14-collapse" aria-expanded="false" onClick={() => setIsOpenRangoPrecios(!isOpenRangoPrecios)}>

                                <i className="fa-solid fa-bell-concierge" style={{ paddingRight: "10px" }}></i>{" "}<strong >{t("RANGO DE PRECIOS")}</strong>
                            </button>
                            <div role="region" ngbaccordioncollapse="" id="ngb-accordion-item-14-collapse" aria-labelledby="ngb-accordion-item-14-toggle" className={`accordion-collapse collapse ${isOpenRangoPrecios ? 'show' : ''}`}>
                                <div ngbaccordionbody="" className="accordion-body">
                                    <RangeSlider
                                        min={precioMinimo / 2}
                                        max={precioMaximo * 2}
                                        initialMin={precioMinimo}
                                        initialMax={precioMaximo}
                                    />
                                </div>

                            </div>
                        </div>

                        <div className="accordion-item" id="ngb-accordion-item-3">
                            <button type="button" ngbaccordionbutton="" className="accordion-button collapsed" id="ngb-accordion-item-3-toggle" aria-controls="ngb-accordion-item-3-collapse" aria-expanded="false" onClick={() => setIsOpenServicios(!isOpenServicios)}>

                                <i className="fa-solid fa-bell-concierge" style={{ paddingRight: "10px" }}></i>{" "}<strong >{t("SERVICIOS")}</strong>
                            </button>
                            <div role="region" ngbaccordioncollapse="" id="ngb-accordion-item-3-collapse" aria-labelledby="ngb-accordion-item-3-toggle" className={`accordion-collapse collapse ${isOpenServicios ? 'show' : ''}`}>
                                <div ngbaccordionbody="" className="accordion-body">
                                    {/* <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="ser_0_Animación adultos" />
                                        <label className="form-check-label" htmlFor="ser_0_Animación adultos">{t("Animación adultos")}</label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="ser_1_Dog Friendly" />
                                        <label className="form-check-label" htmlFor="ser_1_Dog Friendly">{t("Dog Friendly")}</label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="ser_2_Todo Incluido" />
                                        <label className="form-check-label" htmlFor="ser_2_Todo Incluido">{t("Todo Incluido")}</label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="ser_3_Animación infantil" />
                                        <label className="form-check-label" htmlFor="ser_3_Animación infantil">{t("Animación infantil")}</label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="ser_4_Paquetes Golf" />
                                        <label className="form-check-label" htmlFor="ser_4_Paquetes Golf">{t("Paquetes Golf")}</label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="ser_5_Wi-Fi" />
                                        <label className="form-check-label" htmlFor="ser_5_Wi-Fi">{t("Wi-Fi")}</label>
                                    </div>

                                    */}
                                </div>

                            </div>
                        </div>
                        <div className="accordion-item" id="ngb-accordion-item-4">
                            <button type="button" ngbaccordionbutton="" className="accordion-button collapsed" id="ngb-accordion-item-4-toggle" aria-controls="ngb-accordion-item-4-collapse" aria-expanded="false" onClick={() => setIsOpenPromociones(!isOpenPromociones)}>

                                <i className="fa-solid fa-ticket" style={{ paddingRight: "10px" }}></i>{" "}<strong >{t("PROMOCIONES")}</strong>
                            </button>
                            <div role="region" ngbaccordioncollapse="" id="ngb-accordion-item-4-collapse" aria-labelledby="ngb-accordion-item-4-toggle" className={`accordion-collapse collapse ${isOpenPromociones ? 'show' : ''}`}>
                                <div ngbaccordionbody="" className="accordion-body">
                                    {/*
                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="prom_0_Primavera con 20% de descuento" />
                                        <label className="form-check-label" htmlFor="prom_0_Primavera con 20% de descuento">{t("Primavera con 20% de descuento")}</label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="prom_1_Salou y Cambrils: la esencia mediterránea con hasta -25%. Código: DORADA26" />
                                        <label className="form-check-label" htmlFor="prom_1_Salou y Cambrils: la esencia mediterránea con hasta -25%. Código: DORADA26">{t("Salou y Cambrils: la esencia mediterránea con hasta -25%. Código: DORADA26")}</label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="prom_2_Vive Privilege: Hasta -25% + transfer &amp; tour incluidos" />
                                        <label className="form-check-label" htmlFor="prom_2_Vive Privilege: Hasta -25% + transfer &amp; tour incluidos">{t("Vive Privilege: Hasta -25% + transfer &amp; tour incluidos")}</label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="prom_3_Vacaciones en familia en Canarias, Salou, Cambrils o el Caribe con hasta un 25% de descuento. Código: KIDS26" />
                                        <label className="form-check-label" htmlFor="prom_3_Vacaciones en familia en Canarias, Salou, Cambrils o el Caribe con hasta un 25% de descuento. Código: KIDS26">{t("Vacaciones en familia en Canarias, Salou, Cambrils o el Caribe con hasta un 25% de descuento. Código: KIDS26")}</label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="prom_4_Escapada de verano en The One con hasta -20% en la estancia y -15% en gastronomía. Código: THEONESUMM" />
                                        <label className="form-check-label" htmlFor="prom_4_Escapada de verano en The One con hasta -20% en la estancia y -15% en gastronomía. Código: THEONESUMM">{t("Escapada de verano en The One con hasta -20% en la estancia y -15% en gastronomía. Código: THEONESUMM")}</label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="prom_5_Larga estancia: 5% dto. extra" />
                                        <label className="form-check-label" htmlFor="prom_5_Larga estancia: 5% dto. extra">{t("Larga estancia: 5% dto. extra")}</label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="prom_6_Dto. desayuno" />
                                        <label className="form-check-label" htmlFor="prom_6_Dto. desayuno">{t("Dto. desayuno")}</label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="prom_7_Transfer gratis" />
                                        <label className="form-check-label" htmlFor="prom_7_Transfer gratis">{t("Transfer gratis")}</label>
                                    </div>

                                    <div className="mb-2 form-check">
                                        <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-valid" id="prom_8_Ganadores Booking Traveller Review Awards" />
                                        <label className="form-check-label" htmlFor="prom_8_Ganadores Booking Traveller Review Awards">{t("Ganadores Booking Traveller Review Awards")}</label>
                                    </div>

                                    */}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="c-clp-filtros_footer d-md-none">
                    <button type="button" className="btn btn-primary">{t("Aplicar filtros")}</button>
                </div>
            </div >
        </div>
    );
}

export default FilterSection;
